// Personal libs
import { IApiResponse } from '@shared/interface/api-response.interface';
import { apiPost } from './common/api';
import endpoints from 'src/shared/service/endpoint/endpoints.class';
import { ApiStatusEnum } from '@shared/enum/api-enum';
import { ApiError } from '@shared/error/api.error';
import { dbUpdateActiveUsername } from '../local/user.database';
import { sessionManager } from '@shared/service/sessionManager/session-manager.class';
import { logger } from '@shared/lib/logger/logger-manager';
import { manageApiError } from './common/api.lib';

/**
 * Update the user password
 * @param email
 * @returns
 */
export interface IApiUpdatePassword {
  currentPassword: string;
  newPassword: string;
  newPasswordConfirm: string;
  csrf?: string;
}
export const apiUpdatePassword = (
  params: IApiUpdatePassword,
): Promise<string | undefined> => {
  const endpointClass = endpoints.user.postUpdatePassword;
  return apiPost(endpointClass.getUrl(), params, {
    publicApi: endpointClass.isPublic(),
  })
    .then((response: IApiResponse<string, string>) => {
      if (
        response.returnCode === 'USER_UPDATE_PASSWORD_OK' &&
        response.returnStatus === ApiStatusEnum.SUCCESS
      ) {
        return response.returnSuccess;
      } else {
        throw new ApiError(response.returnError ?? '', response.returnCode);
      }
    })
    .catch((error: ErrorConstructor) => manageApiError(error, 'apiAddUser'));
};

/**
 * Update the user's username
 * @param email
 * @returns
 */
export interface IApiUpdateUsername {
  username: string;
  csrf?: string;
}
export const apiUpdateUsername = (
  params: IApiUpdateUsername,
): Promise<string | undefined> => {
  const endpointClass = endpoints.user.postUpdateUsername;
  return apiPost(endpointClass.getUrl(), params, {
    publicApi: endpointClass.isPublic(),
  })
    .then((response: IApiResponse<string, string>) => {
      if (
        response.returnCode === 'USER_UPDATE_USERNAME_OK' &&
        response.returnStatus === ApiStatusEnum.SUCCESS
      ) {
        dbUpdateActiveUsername(params.username);

        if (sessionManager.currentUser.value != null) {
          sessionManager.currentUser.value = {
            ...sessionManager.currentUser.value,
            username: params.username,
          };
        }

        return response.returnSuccess;
      } else {
        throw new ApiError(response.returnError ?? '', response.returnCode);
      }
    })
    .catch((error: ErrorConstructor) =>
      manageApiError(error, 'apiUpdateUsername'),
    );
};

/**
 * User loggout
 * @returns
 */
export const apiLoggout = (): Promise<string | undefined> => {
  const endpointClass = endpoints.user.postLoggout;
  return apiPost(endpointClass.getUrl(), undefined, {
    publicApi: endpointClass.isPublic(),
  })
    .then((response: IApiResponse<string, string>) => {
      if (
        response.returnCode === 'USER_LOGGOUT_OK' &&
        response.returnStatus === ApiStatusEnum.SUCCESS
      ) {
        return response.returnSuccess;
      } else {
        throw new ApiError(response.returnError ?? '', response.returnCode);
      }
    })
    .catch((error: ErrorConstructor) => {
      logger?.error(error);
      return undefined;
    });
};
